<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro">
      <a-select
        mode="multiple"
        style="width: 100%"
        @change="info.setValue()"
        :showArrow="true"
        :disabled="info.disabled"
        v-model="info.value"
        placeholder="请选择"
      >
        <a-select-option v-for="o in info.listOptions" :key="o.optionValue">
          {{ o.optionValue }}
        </a-select-option>
      </a-select>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SCheckboxSelect",
  props: {
    info: {}
  }
};
</script>

<style scoped></style>
